import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GenericApiErrorComponent } from '../generic-api-error/generic-api-error.component';

@Component({
  selector: 'ten-entertainment-ticket-api-error',
  standalone: true,
  imports: [TranslateModule,AsyncPipe],
  templateUrl: './entertainment-ticket-api-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntertainmentTicketApiErrorComponent extends GenericApiErrorComponent {

}
